import axiosClient from './axiosClient';
export default {
  getfile: (filename, contribuenteId) =>
    axiosClient.get(`/files/documenti/${filename}`, {
      params: contribuenteId ? { contribuenteId } : {},
      responseType: 'blob',
    }),
};